import { useState } from "react";
import AddButton from "../../../components/AddButton";
import {
  ArrowUpCircleIcon,
  FunnelIcon,
  QrCodeIcon,
} from "@heroicons/react/24/solid";
import AddProducersForm from "./AddProducersForm";
import AddProducersMainForm from "./AddProducersMainForm";
import TableFilters from "./TableFilters";
import DownloadButton from "../../../components/DownloadButton";
import MassUploadButton from "../../../components/MassUploadButton";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { PERMISSIONS } from "../../PermissionsConstants";
import MaterialExTable from "../../../components/tables/MaterialExTable";
import ProducerCodeFullPageGrpTbl from "./ProducerCodeFullPageGrpTbl";
import {
  prodEditState,
  isForFranchiseDataState,
  prodAddState,
  prodCodeMastercarrierId,
  isProdCodeFilterOpen,
  prodCodeShowState,
  prodCodeViewData,
} from "./atoms/atoms";
import EditProducerCodeModal from "./EditProducerCodeModal";
import ConfirmBoxFranchiseModal from "../../../components/ConfirmBoxFranchiseModal";

const ProducerCodeMainTable = ({
  handleExportButton,
  data,
  setFilters,
  states,
  handleAddContactRow,
  handleProducerCodeInputs,
  handleRemovecarrierAddress,
  handleAddcarrierProducerCodeRow,
  handleAddProducerCodeRow,
  handleRemoveProducerCodeRow,
  carrierProducerCodeData = [],
  carrierOptions,
  newStateRow,
  addStatus,
  distChannelOpts,
  handleClickSave,
  addMainProducerCode,
  setAddMainProducerCode,
  searcProdCodeRefetch,
  setFilterStatus,
  setMassUploadModal,
  setcarrierProducerCodeData,
  carrierProducerCodeRow,
  setCarriers,
  tableloading,
  saveDisabled,
  handleMACheckBox,
  handleIsFranchise,
  saveModal,
  setSaveModal,
  setFilteredproducerCodeData,
  buttonText,
  args,
  setModalArgs,
  setIsFilterMainTable,
  groupedProducerCodes,
  isDownloading,
  setIsDownloading,
}) => {
  const [filter, setFilter] = useRecoilState(isProdCodeFilterOpen);
  const [addProducerCode, setAddProducerCode] = useState(false);
  const [selectedStates, setSelectedStates] = useState([]);
  const [addMainForm, setAddMainForm] = useState(false);
  const [, setClearFilter] = useState(false);
  const [openFranchiseModal, setOpenFranchiseModal] = useState(false);
  const [viewProdCodes, setViewProdCodes] = useRecoilState(prodCodeShowState);
  const [detailWidth, setdetailWidth] = useState(null);
  const setAddIsForFranchise = useSetRecoilState(isForFranchiseDataState);
  const prodEdit = useRecoilValue(prodEditState);
  const [rowViewData, setRowViewData] = useRecoilState(prodCodeViewData);
  const [addState, setAddState] = useRecoilState(prodAddState);
  const [, setMasterCarrierId] = useRecoilState(prodCodeMastercarrierId);
  const addPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_add;
  const viewPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_view;
  const userPermissions = useRecoilValue(permissionsSelector);

  const handleMultiStateSelect = (s) => {
    setSelectedStates(s);
  };

  const onClickCarrierName = (rowData) => {
    setViewProdCodes(true);
    setRowViewData({ ...rowData });
  };

  const updatedProdCodeData =
    data &&
    data?.filter((x) => x.masterCarrierId === rowViewData?.masterCarrierId)[0];

  const matColumns = [
    {
      // title: "Carrier Information",
      name: "Carrier Information",
      cellStyle: {
        fontWeight: "bold",
        textTransform: "uppercase",
        color: "#0C77BD",
      },

      // width: "100%",
      render: (row) => (
        <div>
          <div
            className=" cursor-pointer w-full text-quinary font-bold font-sans text-base uppercase"
            onClick={() => {
              onClickCarrierName(row);
            }}
          >
            <span className="blueAndBold underline">{row.carrierName}</span>
          </div>
          <div className="w-full font-bold text-quinary uppercase"></div>
          <div className="text-xxs font-normal text-gray-600 uppercase">
            Carrier Name
          </div>{" "}
        </div>
      ),
    },
    {
      field: "MasterCarrierAddress",
      type: "string",
      dateSetting: { locale: "en-US" },
      render: (row) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div className="blueAndBold uppercase">
              {row.masterCarrierAddress
                ? row.masterCarrierAddress
                : "unspecified"}
            </div>

            <div className={`mainLabeltextColor`}>Carrier Address</div>
          </div>
        );
      },
    },
    {
      field: "isActive",
      render: (rowData) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div className="blueAndBold uppercase">
              {rowData.isActive === true ? "Active" : "Inactive"}
            </div>
            <div className="mainLabeltextColor">Status</div>
          </div>
        );
      },
    },
  ];

  const handleDataFranchiseSelection = (isFranchise) => {
    setOpenFranchiseModal(false);
    setAddIsForFranchise(isFranchise);
    setAddMainProducerCode(true);
    setAddMainForm(true);
  };

  return (
    <div className="px-8 shadow-xl bg-white pt-4 ">
      {addProducerCode || addMainProducerCode || prodEdit ? (
        ""
      ) : (
        <>
          <div className="">
            <div className="">
              {viewProdCodes ? (
                <div></div>
              ) : (
                <div>
                  <div className="flex gap-2 items-center">
                    <div>
                      <QrCodeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                    </div>
                    <div className="flex flex-col leading tight">
                      <h3 className="text-xs font-medium text-gray-500">
                        Producer Code Module
                      </h3>
                      <h1 className="mr-auto font-bold text-primary text-md uppercase">
                        All Carrier Producer Codes
                      </h1>
                    </div>
                  </div>

                  <div className="flex flex-row justify-between pt-3">
                    {addProducerCode || addMainProducerCode || prodEdit ? (
                      ""
                    ) : (
                      <div className="space-x-4 mr-6">
                        {" "}
                        <button
                          className={`hover:scale-90 transition duration-500 flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs 
                          gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md 
                          ${viewProdCodes && "opacity-50"}`}
                          onClick={() => {
                            setFilter(!filter);
                            setdetailWidth(15);
                          }}
                          disabled={viewProdCodes ? true : false}
                        >
                          <div>Filter By</div>
                          <FunnelIcon className="h-3 w-3 focus:bg-primary" />
                        </button>
                      </div>
                    )}
                    <div className="gap-2 flex items-center">
                      {addProducerCode || addMainProducerCode || prodEdit ? (
                        ""
                      ) : userPermissions.includes(addPermission) ? (
                        <AddButton
                          buttonText="Add"
                          onClick={() => {
                            setcarrierProducerCodeData([
                              carrierProducerCodeRow,
                            ]);
                            setClearFilter(true);
                            setFilter(false);
                            setFilterStatus(false);
                            setAddMainProducerCode(true);
                            setAddMainForm(true);
                            setdetailWidth(10);
                          }}
                        />
                      ) : (
                        ""
                      )}

                      {addProducerCode || addMainProducerCode || prodEdit ? (
                        ""
                      ) : (
                        <div className="flex items-center gap-2">
                          {userPermissions.includes(addPermission) ? (
                            <MassUploadButton
                              onClickFunction={() => {
                                setMassUploadModal(true);
                                setClearFilter(true);
                              }}
                              className="hover:scale-90 transition duration-500 bg-tranparent border-quaternary shadow-md hover:bg-quaternary text-quaternary group relative flex justify-center items-center py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70"
                            >
                              <ArrowUpCircleIcon className="h-4 w-4 mr-2" />
                              <p className="-mt-px   "> Mass Upload</p>
                            </MassUploadButton>
                          ) : (
                            ""
                          )}
                          {userPermissions.includes(viewPermission) ? (
                            <DownloadButton
                              buttonValue={
                                isDownloading ? "Downloading" : "Download File"
                              }
                              onClick={() => {
                                handleExportButton();
                                setIsDownloading(true);
                                setClearFilter(true);
                              }}
                              disabled={isDownloading ? true : false}
                              className="hover:scale-90 transition duration-500 bg-tranparent border-quinary shadow-md hover:bg-quinary text-quinary group relative flex justify-center items-center py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary focus:ring-opacity-70"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
      <div className="">
        {addProducerCode && (
          <AddProducersForm
            Cancel={() => setAddProducerCode(false)}
            newStateRow={newStateRow}
            handleMultiSelect={handleMultiStateSelect}
            handleAddContactRow={handleAddContactRow}
            handleProducerCodeInputs={handleProducerCodeInputs}
            handleRemovecarrierAddress={handleRemovecarrierAddress}
            handleAddcarrierProducerCodeRow={handleAddcarrierProducerCodeRow}
            handleAddProducerCodeRow={handleAddProducerCodeRow}
            handleRemoveProducerCodeRow={handleRemoveProducerCodeRow}
            carrierProducerCodeData={carrierProducerCodeData}
            selectedStates={selectedStates}
            addMainForm={false}
            addStatus={addStatus}
            distChannelOpts={distChannelOpts}
            hideActionColumn={false}
            saveDisabled={saveDisabled}
            handleMACheckBox={handleMACheckBox}
            handleIsFranchise={handleIsFranchise}
            saveModal={saveModal}
            setSaveModal={setSaveModal}
            buttonText={buttonText}
          />
        )}
        {(addMainProducerCode || addState) && (
          <AddProducersMainForm
            Cancel={() => {
              setAddMainProducerCode(false);
              setAddState(false);
              setMasterCarrierId(undefined);
            }}
            states={states}
            newStateRow={newStateRow}
            handleMultiSelect={handleMultiStateSelect}
            handleAddContactRow={handleAddContactRow}
            handleProducerCodeInputs={handleProducerCodeInputs}
            handleRemovecarrierAddress={handleRemovecarrierAddress}
            handleAddcarrierProducerCodeRow={handleAddcarrierProducerCodeRow}
            handleAddProducerCodeRow={handleAddProducerCodeRow}
            handleRemoveProducerCodeRow={handleRemoveProducerCodeRow}
            carrierProducerCodeData={carrierProducerCodeData}
            handleClickSave={handleClickSave}
            selectedStates={selectedStates}
            addStatus={addStatus}
            distChannelOpts={distChannelOpts}
            addMainForm={addMainForm}
            hideActionColumn={false}
            setCarriers={setCarriers}
            saveDisabled={saveDisabled}
            handleMACheckBox={handleMACheckBox}
            handleIsFranchise={handleIsFranchise}
            saveModal={saveModal}
            setSaveModal={setSaveModal}
            buttonText={buttonText}
            groupedProducerCodes={groupedProducerCodes}
            setcarrierProducerCodeData={setcarrierProducerCodeData}
            carrierProducerCodeRow={carrierProducerCodeRow}
          />
        )}
        {viewProdCodes &&
          !addProducerCode &&
          !addMainProducerCode &&
          !prodEdit &&
          !addState && (
            <ProducerCodeFullPageGrpTbl
              rowData={
                updatedProdCodeData
                  ? updatedProdCodeData
                  : rowViewData
                  ? rowViewData
                  : []
              }
              rowIsExpanded={true}
              modalArgs={args}
              setModalArgs={setModalArgs}
              tableloading={
                tableloading
                  ? tableloading
                  : updatedProdCodeData?.length > 0
                  ? false
                  : true
              }
              states={states}
              carrierOptions={carrierOptions}
              distChannelOpts={distChannelOpts}
              setFilter={setFilter}
              // setViewProdCodes={setViewProdCodes}
            />
          )}
        {prodEdit && (
          <EditProducerCodeModal groupedProducerCodes={groupedProducerCodes} />
        )}
      </div>
      {prodEdit || addProducerCode ? (
        ""
      ) : (
        <main className="flex justify-between">
          {!prodEdit && !addProducerCode && !viewProdCodes && filter && (
            <div className="w-1/4 bg-white">
              <div>
                <TableFilters
                  setFilters={setFilters}
                  searchProducerCode={searcProdCodeRefetch}
                  setFilterStatus={setFilterStatus}
                  setFilteredproducerCodeData={setFilteredproducerCodeData}
                  setIsFilterMainTable={setIsFilterMainTable}
                />
              </div>
            </div>
          )}

          <div>
            {!addProducerCode &&
              !addMainProducerCode &&
              !prodEdit &&
              !viewProdCodes && (
                <MaterialExTable
                  data={data}
                  columns={matColumns}
                  isLoading={tableloading}
                  headerStyle={{
                    display: "none",
                    overflow: "hidden",
                  }}
                  panelWidth={detailWidth}
                />
              )}
            <ConfirmBoxFranchiseModal
              isOpen={openFranchiseModal}
              onClickFranchise={() => {
                handleDataFranchiseSelection(true);
              }}
              onClickNonFranchise={() => {
                handleDataFranchiseSelection(false);
              }}
              onClose={() => setOpenFranchiseModal(false)}
              ModalTitle="Add Producer Code"
              qConfirmation="The Producer Code will be in what data category?"
            />
          </div>
        </main>
      )}{" "}
    </div>
  );
};

export default ProducerCodeMainTable;
